/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description useAskZoe hook
 */

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useRouteProps } from '@zcode-ui/hook'
import { BetaFeature, isBetaFeatureEnabled } from '@zcode/nr-utils'
import type { Location } from 'history'
import { useContext } from 'react'
import { ZOE_MAP_LIST_V2 } from './constants'

const hasBetaFlag = (location: Location) => isBetaFeatureEnabled(location, BetaFeature.ZOE_MAPLIST)

export const useAskZoe = (isCurrentSearchView?: boolean) => {
  const { location } = useRouteProps()
  const { optimizely } = useContext(OptimizelyContext)

  if (hasBetaFlag(location)) {
    return 'SHOW_ZOE_AUTOCOMPLETE_DEFAULT'
  }

  if (!optimizely || !isCurrentSearchView) {
    return
  }

  return optimizely?.activate(ZOE_MAP_LIST_V2)
}
